import { Form, FormGroup, Grid, GridItem } from '@patternfly/react-core'
import * as React from 'react'

import { MultipleSelectComponent } from '@app/components/input/multiple-select'
import { useDomainEventFilters } from '@app/domain/domain-events/domain-events.hooks'

interface ComponentProps {
  onSubjectChanged: (string) => void
  onSourceChanged: (string) => void
  onTypeChanged: (string) => void
}

export const DomainEventsFilter = function ({
  onTypeChanged,
  onSourceChanged,
  onSubjectChanged,
}: ComponentProps) {
  const { sources, subjects, types } = useDomainEventFilters()

  return (
    <Form isHorizontal style={{ backgroundColor: 'white', padding: '1em' }}>
      <Grid hasGutter md={6}>
        <GridItem span={6}>
          <FormGroup label="Type" fieldId="type">
            <MultipleSelectComponent
              onChange={onTypeChanged}
              placeHolderValue={'Filter by Type'}
              values={types}
            />
          </FormGroup>
        </GridItem>
        <GridItem span={6}>
          <FormGroup label="Source" fieldId="source">
            <MultipleSelectComponent
              onChange={onSourceChanged}
              placeHolderValue={'Filter by Source'}
              values={sources}
            />
          </FormGroup>
        </GridItem>

        <GridItem span={6}>
          <FormGroup label="Subject" fieldId="subject">
            <MultipleSelectComponent
              onChange={onSubjectChanged}
              placeHolderValue={'Filter by Subject'}
              values={subjects}
            />
          </FormGroup>
        </GridItem>
      </Grid>
    </Form>
  )
}

export default DomainEventsFilter
